export default {
    assign_billing_account_title: "Assign/Unassign Billing Account",
    assign_billing_account_label: "Billing Account",
    assign_billing_account_input: "IMEI or Serial",
    assign_billing_account_imei: "IMEI",
    assign_billing_account_serial: "Serial",
    assign_billing_account_model: "Model",
    assign_billing_account_assign: "Assign",
    assign_billing_account_device_is_already_added: "The device is already added",
    assign_billing_account_device_has_not_been_found: "The device has not been found",
    assign_billing_account_multiple_success_message: "The billing account was successfully assigned to the devices",
    assign_billing_account_multiple_success_message_unassign: "The billing account was successfully unassigned from the devices",
    assign_billing_account_error_message: "Unable to assign the billing account due to an error",
    assign_billing_account_error_message_unassign: "Unable to unassign the billing account due to an error",
    assign_billing_account_unassign: "Unassign",
    assign_billing_account_current_billing_account: "Current Billing Account",
    assign_billing_account_select_billing_account: "Pleace select a Billing Account first",
}

